import { Component, computed, input } from '@angular/core';
import { CoreIcons, LucideAngularModule } from '../../shared/core-icons';
import {
  PASSWORD_RULE_LABELS,
  PASSWORD_RULES,
  validatePassword,
} from '../../utils/password-policy';

@Component({
  selector: 'app-password-policy-hints',
  imports: [LucideAngularModule],
  templateUrl: './password-policy-hints.component.html',
  styleUrls: ['./password-policy-hints.component.scss'],
})
export class PasswordPolicyHintsComponent {
  readonly icons = CoreIcons;
  readonly password = input.required<string>();
  readonly username = input<string>('');

  readonly rules = computed(() => {
    const missing = validatePassword(this.password(), { username: this.username() }).missing;
    return PASSWORD_RULES.map((rule) => ({
      label: PASSWORD_RULE_LABELS[rule],
      met: !missing.includes(rule),
    }));
  });
}
